import { useSocketStatusStore } from "@/store/socketStatus";
import { Wifi, WifiOff } from "lucide-react";

export default function SocketStatus() {
  const { isConnected } = useSocketStatusStore();

  return (
    <div className="flex items-center gap-2" title={isConnected ? "متصل" : "قطع شده"}>
      <div className="relative">
        {isConnected ? (
          <>
            <Wifi 
              size={18} 
              className="text-green-500" 
            />
            <span className="absolute top-0 right-0 flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
            </span>
          </>
        ) : (
          <>
            <WifiOff 
              size={18} 
              className="text-gray-400" 
            />
            <span className="absolute top-0 right-0 flex h-2 w-2">
              <span className="relative inline-flex rounded-full h-2 w-2 bg-gray-400"></span>
            </span>
          </>
        )}
      </div>
    </div>
  );
}

